import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { FbIcon } from "../atoms/icons/fb-icon";
import { TwitterIcon } from "../atoms/icons/twitter-icon";
import assetify from "@quintype/framework/assetify";
import whatsapp from "../../../assets/images/whatsapp.svg";
import Clipboard from "../../../assets/images/clipboard.svg";

import "./social-share-template.m.css";

const SocialShareTemplate = props => {
  const CopyText = () => {
    document.execCommand("copy");
    const textArea = document.createElement("textarea");
    document.body.appendChild(textArea);
    textArea.value = props.fullUrl;
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    window.alert("Link copied");
  };

  return (
    <ul styleName="social-link-list">
      <li>
        <a href={props.fbUrl} target="_blank" rel="noopener noreferrer">
          <FbIcon />
        </a>
      </li>
      <li>
        <a href={props.twitterUrl} target="_blank" rel="noopener noreferrer">
          <TwitterIcon />
        </a>
      </li>
      <li>
        <a href={props.whatsappUrl} target="_blank" rel="noopener noreferrer">
          <img src={assetify(whatsapp)} alt="whatsapp" />
        </a>
      </li>
      <li>
        <img
          style={{ cursor: "pointer" }}
          src={`${assetify(Clipboard)}`}
          alt="copy"
          onClick={() => CopyText()}
          title="Copy link"
        />
      </li>
    </ul>
  );
};

SocialShareTemplate.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  fullUrl: PropTypes.string
};

const mapStateToProps = state => {
  return {
    currentHostUrl: get(state, ["qt", "currentHostUrl"], "")
  };
};

export default connect(mapStateToProps, null)(SocialShareTemplate);
